const LIGHT_MODE_META_TAGS = [
  '<meta http-equiv="x-apple-disable-message-reformatting" />',
  '<meta name="color-scheme" content="light" />',
  '<meta name="supported-color-schemes" content="light" />',
];

const LIGHT_MODE_STYLE_BLOCK = [
  '<style type="text/css" data-bay-light-mode="true">',
  ':root { color-scheme: light !important; supported-color-schemes: light !important; }',
  'html, body { background-color: #ffffff !important; }',
  '[data-ogsc] body, [data-ogsb] body { background-color: #ffffff !important; }',
  '</style>',
].join('');

const escapeRegexValue = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const ensureBodyLightModeStyle = (html: string): string => {
  return html.replace(/<body([^>]*)>/i, (match, attributes = '') => {
    if (/color-scheme\s*:\s*light/i.test(attributes) && /supported-color-schemes\s*:\s*light/i.test(attributes)) {
      return match;
    }

    if (/style\s*=\s*(["'])(.*?)\1/i.test(attributes)) {
      return match.replace(/style\s*=\s*(["'])(.*?)\1/i, (styleMatch, quote, styleValue = '') => {
        const normalizedStyle = styleValue.trim();
        const separator = normalizedStyle.length && !normalizedStyle.endsWith(';') ? '; ' : ' ';
        const lightModeStyle = 'color-scheme: light !important; supported-color-schemes: light !important;';
        return `style=${quote}${normalizedStyle}${separator}${lightModeStyle}${quote}`;
      });
    }

    return `<body${attributes} style="color-scheme: light !important; supported-color-schemes: light !important;">`;
  });
};

export const enforceLightModeHtml = (html: string): string => {
  if (typeof html !== 'string' || !html.trim()) {
    return html;
  }

  let hardenedHtml = html;

  for (const metaTag of LIGHT_MODE_META_TAGS) {
    const metaNameMatch = metaTag.match(/name="([^"]+)"/i);
    const metaHttpEquivMatch = metaTag.match(/http-equiv="([^"]+)"/i);

    if (metaNameMatch?.[1]) {
      const metaName = escapeRegexValue(metaNameMatch[1]);
      const hasMeta = new RegExp(`<meta\\s+[^>]*name=["']${metaName}["'][^>]*>`, 'i').test(hardenedHtml);
      if (!hasMeta) {
        hardenedHtml = hardenedHtml.replace(/<head([^>]*)>/i, `<head$1>${metaTag}`);
      }
      continue;
    }

    if (metaHttpEquivMatch?.[1]) {
      const metaHttpEquiv = escapeRegexValue(metaHttpEquivMatch[1]);
      const hasMeta = new RegExp(`<meta\\s+[^>]*http-equiv=["']${metaHttpEquiv}["'][^>]*>`, 'i').test(hardenedHtml);
      if (!hasMeta) {
        hardenedHtml = hardenedHtml.replace(/<head([^>]*)>/i, `<head$1>${metaTag}`);
      }
    }
  }

  if (!/data-bay-light-mode=["']true["']/i.test(hardenedHtml)) {
    hardenedHtml = hardenedHtml.replace(/<head([^>]*)>/i, `<head$1>${LIGHT_MODE_STYLE_BLOCK}`);
  }

  return ensureBodyLightModeStyle(hardenedHtml);
};
